import {
  IndicatorProps as MantineIndicatorProps,
  Indicator as MantineIndicator,
} from '@mantine/core';

export type IndicatorProps = MantineIndicatorProps;

export const Indicator = MantineIndicator;

Indicator.displayName = 'Indicator';
